export const adminConfigurationTest = `
  function Get-EmailFromUserIdentity {
    $userIdentityLine = dsregcmd /status | Select-String "User Identity" -ErrorAction SilentlyContinue
    $email = ""
    if ($userIdentityLine -match ":\\s*(.+)") {
      $email = $matches[1].Trim()
    }

    return $email
  }


  function Get-EmailFromRegistry {
    param(
        [string]$UserSID
    )
    
    try {
        # Create a new PSDrive for the user's hive if not already mounted
        if (-not (Test-Path "HKU:\\")) {
            New-PSDrive -Name HKU -PSProvider Registry -Root HKEY_USERS | Out-Null
        }
        
        # Check Outlook registry paths
        $outlookPaths = @(
            "HKU:\\$UserSID\\Software\\Microsoft\\Office\\16.0\\Outlook\\Profiles\\Outlook\\9375CFF0413111d3B88A00104B2A6676",
            "HKU:\\$UserSID\\Software\\Microsoft\\Office\\Outlook\\Settings"
        )
        
        foreach ($path in $outlookPaths) {
            if (Test-Path $path) {
                $emailProperty = Get-ItemProperty -Path $path -Name "Email" -ErrorAction SilentlyContinue
                if ($emailProperty -and $emailProperty.Email) {
                    return $emailProperty.Email
                }
            }
        }
        
        # Check Teams registry paths
        $teamsPath = "HKU:\\$UserSID\\Software\\Microsoft\\Teams"
        if (Test-Path $teamsPath) {
            $configFiles = Get-ChildItem -Path "$env:APPDATA\\Microsoft\\Teams\\*.json" -ErrorAction SilentlyContinue
            foreach ($file in $configFiles) {
                $content = Get-Content $file -Raw -ErrorAction SilentlyContinue
                if ($content -match '"email":"([^"]+)"') {
                    return $matches[1]
                }
            }
        }
    } catch {
        Write-Host "Error checking registry for email: $_"
    }
    return $null
  }


  function Get-AzureADJoinInfo {
    try {
        $joinInfo = Get-ItemProperty "HKLM:\\SYSTEM\\CurrentControlSet\\Control\\CloudDomainJoin\\JoinInfo\\*" -ErrorAction SilentlyContinue
        if ($joinInfo -and $joinInfo.UserEmail) {
            return $joinInfo.UserEmail
        }
    } catch {
        Write-Host "Error getting Azure AD join info: $_"
    }
    return $null
  }


  function Get-EmailFromOneDrive {
    param(
        [string]$Username
    )
    
    try {
        $oneDrivePath = "C:\\Users\\$Username\\AppData\\Local\\Microsoft\\OneDrive\\settings\\Business1"
        if (Test-Path $oneDrivePath) {
            $configFiles = Get-ChildItem -Path $oneDrivePath -Filter "*.dat" -ErrorAction SilentlyContinue
            foreach ($file in $configFiles) {
                $content = Get-Content $file -Raw -ErrorAction SilentlyContinue
                if ($content -match "([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,})") {
                    return $matches[1]
                }
            }
        }
    } catch {
        Write-Host "Error checking OneDrive configuration: $_"
    }
    return $null
  }

  function Get-EmailFromEnrollments {
     $enrollments = Get-ChildItem "HKLM:\\SOFTWARE\\Microsoft\\Enrollments\\" -ErrorAction SilentlyContinue

    foreach ($entry in $enrollments) {
      $props = Get-ItemProperty -Path $entry.PSPath -ErrorAction SilentlyContinue
      if ($props.UPN) {
        Write-Output "Found UPN: $($props.UPN)"
        return $props.UPN
        break
      }
    }
  }

  $explorerProcesses = Get-WmiObject Win32_Process -Filter "Name='explorer.exe'"
  if (-not $explorerProcesses) {
      Write-Host "No explorer.exe processes found."
      return $null
  }

  $loggedInUser = ($explorerProcesses | ForEach-Object { $_.GetOwner() } | Select-Object -First 1)
  $username = $loggedInUser.User
  $domain = $loggedInUser.Domain
  $userSID = (New-Object System.Security.Principal.NTAccount("$domain\\$username")).Translate([System.Security.Principal.SecurityIdentifier]).Value

  Write-Host "Found logged-in user: $domain\\$username (SID: $userSID)"

  $email = Get-EmailFromUserIdentity

  if ($email) {
    Write-Host "Detected email from User Identity: $email"
  } else {
    Write-Host "Unable to detect email from User Identity"
  }

  $email = Get-EmailFromEnrollments

  if ($email) {
    Write-Host "Detected email from Enrollments: $email"
  } else {
    Write-Host "Unable to detect email from Enrollments"
  }

  $email = Get-EmailFromRegistry -UserSID $userSID

  if ($email) {
    Write-Host "Detected email from Registry: $email"
  } else {
    Write-Host "Unable to detect email from Registry"
  }

  $email = Get-AzureADJoinInfo

  if ($email) {
    Write-Host "Detected email from Azure AD join info: $email"
  } else {
    Write-Host "Unable to detect email from Azure AD join info"
  }

  $email = Get-EmailFromOneDrive -Username $username

  if ($email) {
    Write-Host "Detected email from OneDrive configuration: $email"
  } else {
    Write-Host "Unable to detect email from OneDrive configuration"
  }
`;

export const userConfigurationTest = `
  $email = whoami /upn

  Write-Host "Retrieved user identity from whoami: $email"

  $azureAdJoinInfo = Get-ItemProperty "HKLM:\\SYSTEM\\CurrentControlSet\\Control\\CloudDomainJoin\\JoinInfo\\*" -ErrorAction Stop
  Write-Host "Retrieved email from Azure AD Join info: $($azureAdJoinInfo.UserEmail)"
`;
